import React from 'react';
import { BubbleNavigation } from '../BubbleUI';
import { useActiveProperty } from '@go-client/context/ActivePropertyContext';
import {
  LIBRARIES_SUBNAV_ARRAY,
  LIBRARIES_SUBNAV_TYPE,
  resolveLibrariesPath,
} from '@go-client/routes';
import { capitalize } from '@go-shared/lib/string';

export function LibrariesSubNavigation(props: { active: LIBRARIES_SUBNAV_TYPE }) {
  const { activeProperty: property } = useActiveProperty();

  return (
    <BubbleNavigation
      appearance="squared"
      items={LIBRARIES_SUBNAV_ARRAY.map(e => ({
        name: capitalize(e),
        to: resolveLibrariesPath(property._id, e),
        active: props.active === e,
        variant: 'titanium',
      }))}
    />
  );
}
